<template>
  <div class="form-horizontal">
    <div class="form-group">
      <label class="col-sm-2 control-label">衣服类型</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" placeholder="衣服类型" v-model="price.name" @input="onPhoneInput">
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label">价格</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" placeholder="价格" v-model.number="price.priceString" @input="onPhoneInput">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['price'],
  methods: {
    onPhoneInput() {
      this.$emit('onPhoneInput')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/forms/Price.vue